import { useEffect, useState } from 'react';
import Layout from '../components/layout';
import Title from '../components/title';
import { supabase } from '../supabase';
import './tablePage.css';
import searchIcon from '../assets/search.svg';
import deleteIcon from '../assets/delete.svg';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [search, setSearch] = useState('');

  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('general');
  const [targetScreen, setTargetScreen] = useState('');
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const getNotifications = async () => {
    const res = await supabase
      .from('notifications')
      .select('*')
      .order('id', { ascending: false });

    setNotifications(res.data || []);
  };

  useEffect(() => {
    getNotifications();
  }, []);

  const sendNotification = async (e) => {
    e.preventDefault();

    await supabase.from('notifications').insert([{
      title: title,
      message: message,
      type: type,
      target_screen: targetScreen,
      is_read: false,
    }]);

    setTitle('');
    setMessage('');
    setType('general');
    setTargetScreen('');
    setIsCreateOpen(false);
    await getNotifications();
  };

  const updateReadStatus = async (id, isRead) => {
    await supabase
      .from('notifications')
      .update({ is_read: !isRead })
      .eq('id', id);

    await getNotifications();
  };

  const deleteNotification = async (id) => {
    await supabase.from('notifications').delete().eq('id', id);
    await getNotifications();
  };

  const filteredNotifications = notifications.filter((notification) => {
    const value = search.toLowerCase();

    return (
      notification.id.toString().includes(value) ||
      notification.title?.toLowerCase().includes(value) ||
      notification.message?.toLowerCase().includes(value) ||
      notification.type?.toLowerCase().includes(value) ||
      notification.target_screen?.toLowerCase().includes(value)
    );
  });

  return (
    <Layout>
      <div className="table_page">
        <Title subtitle="Send and manage app notifications" title="Notifications" />

        <div className="table_controls_card">
          <label className="table_search">
            <img alt="" src={searchIcon} />
            <input
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search notifications..."
              value={search}
            />
          </label>

          <div className="table_controls_actions">
            <span>{filteredNotifications.length} total records</span>
            <button className="table_primary_button" onClick={() => setIsCreateOpen(true)} type="button">
              Send Notification
            </button>
          </div>
        </div>

        <div className="table_card">
          <div className="table_scroll">
            <table className="data_table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Type</th>
                  <th>Target</th>
                  <th>Read</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredNotifications.map((notification) => (
                  <tr key={notification.id}>
                    <td>{notification.id}</td>
                    <td>{notification.title}</td>
                    <td>{notification.message}</td>
                    <td>{notification.type}</td>
                    <td>{notification.target_screen}</td>
                    <td>{notification.is_read ? 'yes' : 'no'}</td>
                    <td>
                      <div className="table_actions">
                        <button
                          className="table_secondary_button table_small_button"
                          onClick={() => updateReadStatus(notification.id, notification.is_read)}
                          type="button"
                        >
                          {notification.is_read ? 'unread' : 'read'}
                        </button>
                        <button
                          aria-label={`Delete notification #${notification.id}`}
                          className="table_icon_button table_icon_button_danger"
                          onClick={() => deleteNotification(notification.id)}
                          type="button"
                        >
                          <img alt="" src={deleteIcon} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

                {filteredNotifications.length === 0 && (
                  <tr>
                    <td colSpan={7}>No notifications found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {isCreateOpen && (
          <div className="table_modal_overlay" onClick={() => setIsCreateOpen(false)}>
            <div className="table_modal" onClick={(e) => e.stopPropagation()}>
              <div className="table_modal_header">
                <div>
                  <h2>Send Notification</h2>
                </div>
                <button className="table_modal_close" onClick={() => setIsCreateOpen(false)} type="button">
                  x
                </button>
              </div>

              <form className="table_form" onSubmit={sendNotification}>
                <div className="table_form_grid">
                  <label className="table_form_field">
                    <span>Title</span>
                    <input
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Notification title"
                      value={title}
                    />
                  </label>

                  <label className="table_form_field">
                    <span>Type</span>
                    <select onChange={(e) => setType(e.target.value)} value={type}>
                      <option value="general">general</option>
                      <option value="booking">booking</option>
                      <option value="event">event</option>
                      <option value="program">program</option>
                      <option value="startup">startup</option>
                    </select>
                  </label>

                  <label className="table_form_field table_form_field_full">
                    <span>Target Screen</span>
                    <input
                      onChange={(e) => setTargetScreen(e.target.value)}
                      placeholder="Example: bookings"
                      value={targetScreen}
                    />
                  </label>

                  <label className="table_form_field table_form_field_full">
                    <span>Message</span>
                    <textarea
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Write the notification message"
                      rows={3}
                      value={message}
                    />
                  </label>
                </div>

                <div className="table_form_actions">
                  <button className="table_secondary_button" onClick={() => setIsCreateOpen(false)} type="button">
                    Cancel
                  </button>
                  <button className="table_primary_button">Send</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Notifications;
